// @flow
import { parse as parseQs } from "qs";
import { setDefaultLevel, getLogger, LEVELS as LOG_LEVELS } from "common/logger";
import createExternalInterface from "./externalInterface";
import createUploader, { createDummyUploader } from "./createUploader";

const logger = getLogger();

const parseQsParams = () => {
	const parsed = parseQs(self.location.search, { ignoreQueryPrefix: true });

	return {
		debug: parsed.debug,
		cloudName: parsed.cloudName,
		authFlow: parsed.authFlow,
		pmHost: parsed.pmHost,
	};
};

const createFromPostMessage = (qsParams) => {
	require("blueimp-file-upload");

	let uploader = null;

	if (!qsParams.pmHost) {
		logger.warn(`[uploaderInitializer]: can't create uploader without pmHost param! - qs = ${self.location.search}`);
	} else {
		logger.log("[uploaderInitializer]: awaiting for init msg from external code");

		uploader = createUploader({
			createExternalInterface,
			qsParams,
		});
	}

	return uploader;
};

/**
 * Initializes the uploader based on dev config or postmessage info
 * returns the uploader instance as the result of the promise when ready
 * @returns {Promise.<Object>}
 */
export default () => {
	let instance: ?Object;

	const qsParams = parseQsParams();

	if (qsParams.debug) {
		setDefaultLevel(LOG_LEVELS.LOG);
	}

	logger.log("[uploaderInitializer]: loaded qs params : ", qsParams);

	if (qsParams.authFlow) {
		logger.log("[uploaderInitializer]: initializing dummy uploader for auth flow");
		instance = createDummyUploader();
	} else {
		logger.log("[uploaderInitializer]: initializing uploader instance from post message");
		instance = createFromPostMessage(qsParams);
	}

	return instance;
};
